import {useEffect, useContext} from 'react'
import {ReservationContext} from '../../context/Reservation'
import {snap} from '../../utils/ApMath'
import moment from 'moment'

const useAllDayReserveAction = (elementSelector, date, dayCount) => {
  const {update, setPopReserve} = useContext(ReservationContext)
  useEffect(() => {
    // listeners
    const listeners = document.querySelectorAll(elementSelector)
    const refNewEventBar = document.querySelector('.event-bar--new')
    const refContainer = document.querySelector('.events-bar-container')

    let reserveOnOrAfter = moment()
      .add(1, 'day')
      .startOf('day')

    // private variables
    let columnWidth = 0
    let initX = 0
    let startX = 0

    let indexStartX = 0
    let indexEndX = 0

    let hasStarted = false

    // dates
    let start = null
    let end = null

    if (!refNewEventBar) {
      console.warn("__can't find new event bar")
    }

    const handleMouseDown = e => {
      if (e.target.getAttribute('data-x') !== 'all-day-range') return
      let rect = refContainer.getBoundingClientRect()
      initX = e.clientX
      startX = initX - rect.left
      columnWidth = rect.width / dayCount

      const snapStartX = snap(startX, columnWidth, Math.floor)
      indexStartX = Math.max(0, snapStartX / columnWidth)

      start = date
        .clone()
        .add(indexStartX, 'days')
        .startOf('day')
        .set('hour', 8)
      end = date
        .clone()
        .add(indexStartX, 'days')
        .startOf('day')

      if (start.valueOf() >= reserveOnOrAfter.valueOf()) {
        hasStarted = true
        refNewEventBar.style.display = 'flex'
        refNewEventBar.style.left = `${indexStartX * columnWidth}px`
        refNewEventBar.style.right = `${(dayCount - 1 - indexStartX) * columnWidth}px`
        refNewEventBar.textContent = `${start.format('MM/DD')} - ${end.format('MM/DD')} `
      }
    }
    const handleMouseUp = e => {
      if (hasStarted) {
        hasStarted = false
        update('date_from', start)
        update('date_to', end)
        setPopReserve(true)
      }
      refNewEventBar.style.display = 'none'
    }

    const handleMouseMove = e => {
      if (!hasStarted) return

      const snapEndX = snap(startX + (e.clientX - initX), columnWidth, Math.floor)
      indexEndX = Math.max(Math.min(dayCount - 1, snapEndX / columnWidth), indexStartX)

      start = date
        .clone()
        .add(indexStartX, 'days')
        .startOf('day')
        .set('hour', 8)
      end = date
        .clone()
        .add(indexEndX, 'days')
        .startOf('day')
        .set('hour', 18)

      if (start.valueOf() >= reserveOnOrAfter.valueOf()) {
        hasStarted = true
        refNewEventBar.style.left = `${indexStartX * columnWidth}px`
        refNewEventBar.style.right = `${(dayCount - 1 - indexEndX) * columnWidth}px`
        refNewEventBar.textContent = `${start.format('MM/DD')} - ${end.format('MM/DD')}`
      }
    }

    listeners.forEach(ref => {
      ref.addEventListener('mousedown', handleMouseDown)
    })
    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)

    return () => {
      listeners.forEach(ref => {
        ref.removeEventListener('mousedown', handleMouseDown)
      })
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [elementSelector, date, dayCount, update, setPopReserve])
}

export default useAllDayReserveAction
